import Title from "@components/global/new/Title/Title";
import { useLocale } from "@utils/hooks/useLocale";
import cn from "classnames";
import { useIntl } from "react-intl";
import { LocaleLangE } from "../../i18n/LocaleContext";
import Calendar from "./Calendar/Calendar";
import CalendarPeriods from "./CalendarPeriods/CalendarPeriods";
import styles from "./PlanCreator.module.scss";
import { IPlanCreatorProps } from "./PlanCreator.props";
import PlanTemplate from "./PlanTemplate/PlanTemplate";
import { usePlanCreatorControl } from "./usePlanCreatorControl";
import Week from "./Week/Week";
import { Input } from "@components/global/new/Input/Input";
import { Button, Divider } from "antd";
import decodeHTMLEntities from "@utils/decodeHTMLEntities";
import { useEffect } from "react";

export default function PlanCreator(props: IPlanCreatorProps) {
  const {
    // reset,
    // disabled,
    readOnly,
    direction = "horizontal",
  } = props;

  const { formatMessage } = useIntl();
  const { isRus } = useLocale();

  const control = usePlanCreatorControl(props);

  if (readOnly) {
    return <PlanCreator.ReadOnlyMode {...props} />;
  }

  return (
    <div
      // onSubmit={control.onSubmit}
      className={cn(styles.wrapper, {
        [styles.disabled]: control.disabled,
        [styles.in_modal]: direction === "vertical",
      })}
    >
      <div className={styles.content}>
        <div className={styles.calendar_with_weekdays}>
          {!readOnly && (
            <Input
              size="small"
              label={formatMessage({ id: "modal.create_plan.plan.name" })}
              type='text'
              readOnly={control.disabled}
              disabled={control.disabled}
              outlined={!control.disabled}
              value={decodeHTMLEntities(control.planName)}
              wrapClassName={styles.input}
              id='name'
              key={control.reset}
              onChange={control.onChangePlanName}
            />
          )}
          <div>
            <div className={cn(styles.calendar, { [styles.outlined]: !control.disabled })}>
              {!readOnly && <Week readOnly={control.disabled || readOnly} isRus={isRus} days={control.days} />}
              <Calendar
                readOnly={control.disabled || readOnly}
              />
            </div>
            <label className={styles.not_check_text}>
              {formatMessage({
                id: "modal.create_plan.plan.days_not_checked",
              })}
            </label>
          </div>
        </div>
        <div className={styles.periods_column}>
          <CalendarPeriods showTemplates={props.showTemplates} />
          <br />
          {control.isAdmin && (
            <Button
              className={styles.saveButton}
              disabled={control.disabled}
              onClick={control.onSaveClicked}
            >
              {formatMessage({ id: "contracts.btn.save" })}
            </Button>
          )}
        </div>
        <PlanTemplate />
      </div >
    </div>
  );

}

interface IPlanCreatorReadonlyProps extends Omit<IPlanCreatorProps, "closeOnEsc"> {
  readonly hasTitle?: boolean;
  readonly size?: "m" | "s";
}

PlanCreator.ReadOnlyMode = (props: IPlanCreatorReadonlyProps) => {
  const {
    hasTitle = false,
    size = "m",
  } = props;

  const { formatMessage } = useIntl();
  const { locale } = useLocale();
  const isRus = locale === LocaleLangE.RU;
  const control = usePlanCreatorControl({ ...props, closeOnEsc: false });

  return (
    <div
      className={cn(styles.readonly_wrapper, {
        [styles.sizeSmall]: size === "s",
      })}
    >
      {hasTitle && (
        <Title className={cn(styles.title)}>
          <span>{formatMessage({ id: "plan.title" })}</span>{" "}
          {control.plan?.name.toLocaleLowerCase() === "default" ||
            !control.plan?.name
            ? isRus
              ? "По умолчанию"
              : control.plan?.name
            : control.plan?.name}
        </Title>
      )}
      <div className={cn(styles.calendar_wrapper__readonly)}>
        <Calendar readOnly />
      </div >

      <div className={styles.exept}>
        <div className={styles.time_pick}>
          <CalendarPeriods showTemplates={false} size={size} />
        </div>
      </div>
    </div >
  );
};